import React from 'react';
import { ModalDialog, Button, SelectField } from 'vetrf-ui';
import classNames from 'classnames';
import { FormContainer } from 'components/FormContainer';
import { ObjectOperation } from 'api/dict/params';
import { FunctionPermissions, MovementData } from '../../../../../../types/types';
import { FormFields } from './components';

type AddMotionModalProps = {
  onClose: () => void;
  requestFunctions: ObjectOperation[];
  onSubmit: (data: MovementData<File[]>) => void;
  permissions: FunctionPermissions;
  lastStatusDate?: string;
  tempValidDate?: string;
};

export const AddMotionModal = ({
  onClose,
  onSubmit,
  requestFunctions,
  permissions,
  lastStatusDate,
  tempValidDate,
}: AddMotionModalProps) => (
  <FormContainer onSubmit={(data) => onSubmit(data as MovementData<File[]>)}>
    <ModalDialog
      header="Добавить движение заявки"
      onClose={onClose}
      bodyClass={classNames('modal-body')}
      footer={
        <>
          <Button
            type="submit"
            color="success"
            iconColor="white"
            iconSize={100}
            size="sm"
            text="Добавить"
          />
          <Button
            color="grey"
            iconColor="white"
            iconSize={100}
            onClick={onClose}
            size="sm"
            text="Отменить"
          />
        </>
      }
    >
      <SelectField
        labelText="Функция"
        name="operation"
        labelKey="name"
        valueKey="code"
        options={requestFunctions}
        required="Необходимо заполнить поле"
        disabled={permissions.patentee}
      />
      <FormFields
        permissions={permissions}
        requestFunctions={requestFunctions}
        lastStatusDate={lastStatusDate}
        tempValidDate={tempValidDate}
      />
    </ModalDialog>
  </FormContainer>
);
